import { Divider } from 'antd'
import { useState } from 'react'
import ImageUpload from '../components/ImageUpload'
import VideoUpload from '../components/VideoUpload'
import Var360Upload from '../components/Var360Upload'
import MediaPreviewModal from '../components/MediaPreviewModal'

const MediaUpload = ({ value, onChange }) => {
  const [preview, setPreview] = useState({
    open: false,
    media: null
  })

  const update = (key, updater) => {
    onChange((prev) => ({
      ...prev,
      [key]: typeof updater === 'function' ? updater(prev[key] || []) : updater
    }))
  }

  const handlePreview = (item, type) => {
    if (!item?.url || item.uploading) return

    setPreview({
      open: true,
      media: {
        url: item.url,
        type
      }
    })
  }

  return (
    <>
      <Divider orientation="left">Hình ảnh</Divider>
      <ImageUpload
        images={value.images}
        onChange={(v) => update('images', v)}
        onPreview={(item) => handlePreview(item, 'IMAGE')}
      />

      <Divider orientation="left">Video</Divider>
      <VideoUpload
        videos={value.videos}
        onChange={(v) => update('videos', v)}
        onPreview={(item) => handlePreview(item, 'VIDEO')}
      />

      <Divider orientation="left">Ảnh 360</Divider>
      <Var360Upload
        value={value.image_360}
        onChange={(v) => update('image_360', v)}
        onPreview={(item) => handlePreview(item, 'IMAGE360')}
      />

      {/* ✅ Modal preview đặt ở đây */}
      <MediaPreviewModal
        open={preview.open}
        media={preview.media}
        onClose={() => setPreview({ open: false, media: null })}
      />
    </>
  )
}

export default MediaUpload
